import React from "react";

export const projectNameHint = <React.Fragment>
    <p>
        Gib deinem neuen Projekt einen passenden Namen, damit du es im Kundencenter besser wiederfinden kannst. Diesen Projekt-Namen kannst du später jederzeit ändern.
    </p>
</React.Fragment>

export const projectStateHint = <React.Fragment>
    <p>
        Bei Mittwald unterscheiden wir zwischen DEV und LIVE. Nutze DEV-Projekte für die Test- und Entwicklungsphase. Sobald dein Projekt produktiv genutzt wird, überführst du es per Klick in ein kostenpflichtiges LIVE-Projekt.
    </p>
</React.Fragment>;

export const typeHint = <React.Fragment>
    <p>
        Dein Hosting wird für den Betrieb eines <strong>Shops</strong> bzw. einer <strong>Website</strong> optimiert. Shopsysteme sind häufig ressourcenhungriger und erfordern serverseitig andere Konfigurationen als CMS- oder Webprojekte. Natürlich kannst du jeweils
        auch <strong>eigenentwickelte</strong> oder <strong>statische Projekte</strong> hosten.
    </p>
</React.Fragment>;

export const securityHint = <React.Fragment>
    <p>
        Das Projekt-Passwort nutzt du für den Zugriff auf dein Projekt in unserem Kundencenter unter <a href="https://login.mittwald.de" target="_blank">https://login.mittwald.de</a> und auf deine vorinstallierte Software. Den zugehörigen Benutzernamen zum Login in dein Projekt bekommst du
        von uns per E-Mail zugeschickt. Als Agentur-Server-Neukunde erhältst du einen weiteren separaten Zugang per E-Mail, um gesammelt auf alle deine Projekte zugreifen zu können.
    </p>
</React.Fragment>

export const softwareHint = <React.Fragment>
    <p>
        Wähle deine bevorzugte Software bereits jetzt aus, damit wir alle Komponenten für dich installieren können und du direkt loslegen kannst. Du bist dir noch unsicher, welche Software du benötigst? Kein Problem. Deine Softwareauswahl kannst du auch jederzeit im Kundencenter vornehmen.
    </p>
</React.Fragment>

export const visitorHint = <React.Fragment>
    <p>
        Als <strong>ein Besucher</strong> wird jeder User gezählt, der die Website mit <strong>einer IP-Adresse</strong> binnen <strong>24 Std.</strong> beliebig oft besucht.
    </p>
    <p>
        <strong>Bots und API-Aufrufe</strong> werden herausgefiltert und somit aus der Berechnung ausgeschlossen.
    </p>
    <p>
        Kommt es zur <strong>konstanten Überschreitung</strong> der oben aufgeführten Besucherzahl, erfolgt eine <strong>Performance-Einschränkung</strong> in Form einer verlangsamten Seitenauslieferung.
    </p>
</React.Fragment>;

export const storageHint = <React.Fragment>
    <p>
        Mehr als Speicherplatz. Alle <strong>CMS, Shop und Agentur-Tools</strong> sind ab dem kleinsten Projekt schon <strong>inklusive</strong> und können so lange genutzt werden, bis dein Speicherplatz voll ist. Dein Speicherplatz steckt also voller Möglichkeiten.
    </p>
</React.Fragment>;

export const backupHint = <React.Fragment>
    <p>Backups vom Vortag sind inklusive – längere Backupzeiträume optional wählbar. Diese werden vom Speicherplatz abgezogen. Da die Daten inkrementell gesichert werden, vervielfacht sich aber nicht dein Speicherplatzbedarf. So kannst du rechnen:</p>
    <p>
        1 Tag (inkl. - kein Abzug)
        <br/>
        7 Tage (verbrauchter Speicherplatz * 0,2)
        <br/>
        14 Tage (verbrauchter Speicherplatz * 0,5)
        <br/>
        28 Tage (verbrauchter Speicherplatz * 1,0)
    </p>
    <p>Die Einspielung eines Backups wird mit 50 Euro (zzgl. Ust.) berechnet.</p>
</React.Fragment>;



/** WEBPACK FOOTER **
 ** ./src/components/configurator/ArticleConfiguratorTooltip.js
 **/